import React, { useContext } from 'react'
import type IntlManager from './IntlManager'


export const IntlContext = React.createContext<IntlManager>(null)

export const useIntl = () => useContext(IntlContext)
